module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "sellerWrapper",
    staticClass: "seller-wrapper"
  }, [_c('div', {
    staticClass: "seller-content"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.seller.name))]), _vm._v(" "), _c('div', {
    staticClass: "star-wrapper"
  }, [_c('star', {
    attrs: {
      "size": 36,
      "score": _vm.seller.score
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "rate-count"
  }, [_vm._v("(" + _vm._s(_vm.seller.ratingCount) + ")")]), _vm._v(" "), _c('span', {
    staticClass: "sell-count"
  }, [_vm._v("月售" + _vm._s(_vm.seller.sellCount) + "单")])], 1), _vm._v(" "), _c('div', {
    staticClass: "collect",
    on: {
      "click": function($event) {
        _vm.collectFlag = !_vm.collectFlag
      }
    }
  }, [_c('span', {
    staticClass: "icon-favorite",
    class: {
      'active': _vm.collectFlag
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.collectFlag ? '已收藏' : '收藏'))])])]), _vm._v(" "), _c('div', {
    staticClass: "remark"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h2', [_vm._v("起送价")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.seller.minPrice))]), _vm._v("元\r\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h2', [_vm._v("商家配送")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.seller.deliveryPrice))]), _vm._v("元\r\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h2', [_vm._v("平均配送时间")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.seller.deliveryTime))]), _vm._v("分钟\r\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "activities"
  }, [_c('div', {
    staticClass: "bulletin"
  }, [_c('h1', [_vm._v("公告与活动")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.seller.bulletin))])])]), _vm._v(" "), _c('div', {
    staticClass: "supports"
  }, [_c('ul', _vm._l((_vm.seller.supports), function(item) {
    return _c('li', {
      staticClass: "item"
    }, [_c('support-icon', {
      attrs: {
        "supportType": item.type,
        "iconType": 4
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.description))])], 1)
  }))]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "seller-pics"
  }, [_c('h1', [_vm._v("商家实景")]), _vm._v(" "), _c('div', {
    ref: "picsWrapper",
    staticClass: "pics-wrapper"
  }, [_c('div', {
    ref: "picsList"
  }, _vm._l((_vm.seller.pics), function(pic) {
    return _c('img', {
      attrs: {
        "src": pic,
        "width": "120",
        "height": "90"
      }
    })
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "seller-info"
  }, [_c('h1', [_vm._v("商家信息")]), _vm._v(" "), _c('ul', {
    staticClass: "info-list"
  }, _vm._l((_vm.seller.infos), function(info) {
    return _c('li', {
      staticClass: "info"
    }, [_vm._v(_vm._s(info))])
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8a853c02"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Seller.vue
// module id = 245
// module chunks = 1